<pbc-filter [config]="DateiArtsFilterConfig" [filter]="dateiArts.filter$ | async" (filterChange)="dateiArts.filter$.next($event)"></pbc-filter>
